export const containsHTML = (input: string): boolean => {
  const htmlRegex =
    /<([a-zA-Z][\w-]*)(\s*[^>]*)?>[\s\S]*?<\/\1>|<([a-zA-Z][\w-]*)\s*[^>]*\/?>/i;

  return htmlRegex.test(input);
};
